// extracted by mini-css-extract-plugin
module.exports = {"wrap":"oh-z","title":"ph-z","cta":"qh-z","disabled":"rh-z"};